module.exports = __webpack_public_path__ + "static/media/executive.8fc3b03f.png";